import baseReport from '../baseReportImpressao';
import formatDataBRDia from '@/plugins/filters/formatDataBRDia';

const montarAssinatura = (professores, filtros, tipoDeEnsino) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 6.5,
                  margin: [0, 35, 0, 0],
                  text: [
                    '\n___________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
    {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [{ text: 'Obs.: ', bold: true }, (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I') ? 'Este relatório apresenta todas as aulas com frequência correspondentes a campos de experiência.' : 'Este relatório apresenta todas as aulas com frequência correspondentes a disciplina.'],
    },
  ];
};

const conteudoLecionadoReport = async ({ date, time, filtros, data, periodos, periodo, professores, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Conteúdo Lecionado' });

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Período:   ', bold: true },
            filtros.periodo,
          ],
        },
      ],
    },
  ];

  if (data.length <= 0) {
    return {
      ...headerFooter,
      content: [{
        text: 'Nenhuma aula encontrada.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  let periodosFiltered = periodos;
  periodosFiltered.shift();
  let totalGeral = 0;
  if (periodo !== '-1') { periodosFiltered = periodosFiltered.filter(key => key.value === periodo); }
  const dataFormated = periodosFiltered.map((key, index) => {
    let total = 0;
    const aulas = data.filter(n => n.cdpravadi === key.value).map((n) => {
      total += parseInt(n.qnt);
      return [
        { text: `${formatDataBRDia(n.dataaula)}`, alignment: 'left' },
        { text: n.qnt, alignment: 'center' },
        { text: n.descricaoassuntolecionado, alignment: 'left' },
      ];
    });
    totalGeral += total;

    if (aulas.length <= 0) { return {}; }

    return [
      {
        text: `Período Avaliativo: ${key.text}`,
        alignment: 'center',
        bold: true,
        margin: [0, 10, 0, 0],
        fontSize: 10,
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 7,
        table: {
          widths: ['15%', '15%', '*'],
          body: [
            [
              { text: 'Data', style: 'tableHeader' },
              { text: 'N° Aulas', style: 'tableHeader' },
              { text: 'Conteúdo Lecionado', style: 'tableHeader' },
            ],
            ...aulas,
            [
              {
                text: 'Total', bold: true, alignment: 'center', fontSize: 9,
              },
              {
                text: total, bold: true, alignment: 'center', fontSize: 9,
              },
              {},
            ],
          ],
        },
        pageBreak: ((periodosFiltered.length - 1 === index) ? '' : 'after'),
      },
    ];
  });

  const exibirTotalGeral = [];
  if (periodo === '-1') {
    exibirTotalGeral.push({
      margin: [0, 10, 0, 0],
      fontSize: 9,
      bold: true,
      alignment: 'center',
      table: {
        widths: ['15%', '15%', '*'],
        body: [
          ['Total Geral', totalGeral, {}],
        ],
      },
    });
  }

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      ...exibirTotalGeral,
      ...montarAssinatura(professores, filtros, tipoDeEnsino),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
        alignment: 'center',
      },
    },
  };
};

export default conteudoLecionadoReport;
